import { jsx as _jsx } from "react/jsx-runtime";
import { LengthInput } from "../../primitives/LengthInput";
import { CSSEnum } from "./enum-helpers";
import { getEnumOptions } from "./helpers";
export const CSSStringEditor = (props)=>{
    const { // Influences the color
    value, onChangeValue, baseType } = props;
    // We'll try to use the enum hint to render a dropdown or
    // a set of buttons
    const enumOptions = getEnumOptions(value, baseType);
    if (enumOptions) {
        const originalValue = value;
        return /*#__PURE__*/ _jsx(CSSEnum, {
            props: {
                ...props
            },
            onSelectOption: (value)=>{
                console.log(`CSSEnum - onSelectOption`, value);
                onChangeValue && onChangeValue({
                    ...originalValue,
                    type: "css-string",
                    value
                });
            },
            enumOptions: enumOptions
        });
    }
    return /*#__PURE__*/ _jsx(LengthInput, {
        readOnly: !!props.readOnly,
        value: value?.value || "",
        onChange: (e)=>{
            onChangeValue && onChangeValue({
                type: "css-string",
                value: e.target.value || "",
                cssEnumHint: value?.cssEnumHint || undefined
            });
        }
    });
};
